module.exports = __webpack_public_path__ + "static/media/send_icon_vector.830b1423.svg";